import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  return <section className="py-20 px-4 bg-[#0F1F3D]" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <h2 className="text-4xl md:text-5xl font-anton text-center text-white mb-12" data-id="element-45">
          ⚖️ SIN SISTEMA vs CON SISTEMA
        </h2>

        <div className="bg-[#0A1628] rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-46">
          <div className="grid grid-cols-2 bg-black/40" data-id="element-47">
            <div className="p-6 text-center border-r border-white/10" data-id="element-48">
              <h3 className="text-xl font-bold text-red-500 uppercase tracking-widest" data-id="element-49">
                SIN SISTEMA
              </h3>
            </div>
            <div className="p-6 text-center bg-[#C6F432]/10" data-id="element-50">
              <h3 className="text-xl font-bold text-[#C6F432] uppercase tracking-widest" data-id="element-51">
                CON SISTEMA
              </h3>
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-52">
            {[['Horas pensando', '10 minutos'], ['Improvisación', 'Estructura'], ['Caos', 'Control'], ['Alumnos se van', 'Alumnos se quedan'], ['Inseguridad', 'Confianza']].map(([bad, good], i) => <div key={i} className="grid grid-cols-2" data-id="element-53">
                <div className="p-4 md:p-6 text-center border-r border-white/10 flex flex-col items-center justify-center gap-2" data-id="element-54">
                  <X className="text-red-500" size={24} data-id="element-55" />
                  <span className="text-gray-400 font-medium" data-id="element-56">{bad}</span>
                </div>
                <div className="p-4 md:p-6 text-center bg-[#C6F432]/5 flex flex-col items-center justify-center gap-2" data-id="element-57">
                  <Check className="text-[#C6F432]" size={24} data-id="element-58" />
                  <span className="text-white font-bold" data-id="element-59">{good}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-60">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-61">
            💬 Lo que pasa cuando lo usás:
          </h3>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-62">
            <div className="bg-[#0A1628] px-6 py-3 rounded-full border border-[#C6F432]/30 flex items-center gap-2" data-id="element-63">
              <Check className="text-[#C6F432]" size={20} data-id="element-64" />{' '}
              <span className="font-medium" data-id="element-65">Tus clases tienen lógica</span>
            </div>
            <div className="bg-[#0A1628] px-6 py-3 rounded-full border border-[#C6F432]/30 flex items-center gap-2" data-id="element-66">
              <Check className="text-[#C6F432]" size={20} data-id="element-67" />{' '}
              <span className="font-medium" data-id="element-68">Tus alumnos mejoran</span>
            </div>
            <div className="bg-[#0A1628] px-6 py-3 rounded-full border border-[#C6F432]/30 flex items-center gap-2" data-id="element-69">
              <Check className="text-[#C6F432]" size={20} data-id="element-70" />{' '}
              <span className="font-medium" data-id="element-71">Te sentís seguro</span>
            </div>
            <div className="bg-[#0A1628] px-6 py-3 rounded-full border border-[#C6F432]/30 flex items-center gap-2" data-id="element-72">
              <Check className="text-[#C6F432]" size={20} data-id="element-73" />{' '}
              <span className="font-medium" data-id="element-74">Podés cobrar más</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}